/**
 * @ngdoc directive
 * @name dropZone
 * @restrict A
 * @description
 * Detect the drop event on HTML elements.
 *
 * Example:
 * <div drop-zone="callbackFunction(files)"></div>
 *
 * @memberof common
 * @return {Object} The directive properties.
 */
const DropZone = (errorHandler) => {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      dropZone: '&',
    },
    link($scope, $element) {
      const element = $element[0];
      const noPropagation = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      // Prevent the default, stop propagation and handle the dragover event.
      const handleDragover = (e) => {
        let efct;
        try {
          efct = e.dataTransfer.effectAllowed;
        } catch (error) {
          errorHandler.handleError(error);
        }

        e.dataTransfer.dropEffect = efct === 'move' || efct === 'linkMove'
          ? 'move' : 'copy';
        noPropagation(e);
      };
      // Prevent the default, stop propagation and handle the drop event.
      const handleDrop = (e) => {
        noPropagation(e);
        const { dataTransfer: { files } } = e;
        if (files && files.length > 0) {
          $scope.dropZone({ files });
        }
        return false;
      };

      element.addEventListener('drop', handleDrop);
      element.addEventListener('dragover', handleDragover);
      // Disable dragenter
      element.addEventListener('dragenter', noPropagation);

      $scope.$on('$destroy', () => {
        element.removeEventListener('drop', handleDrop);
        element.removeEventListener('dragover', handleDragover);
        element.removeEventListener('dragenter', noPropagation);
      });
    },
  };
};

export default DropZone;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/directives/dropZone.js